import { addDays, endOfMonth, endOfWeek, format, startOfMonth, startOfWeek } from "date-fns";

// Match react-big-calendar's Monday-first localizer and default 30-day Agenda.
export function calendarQueryRange(date, view) {
  let start = date;
  let end = date;
  if (view === "month") {
    start = startOfWeek(startOfMonth(date), { weekStartsOn: 1 });
    end = endOfWeek(endOfMonth(date), { weekStartsOn: 1 });
  } else if (view === "week") {
    start = startOfWeek(date, { weekStartsOn: 1 });
    end = endOfWeek(date, { weekStartsOn: 1 });
  } else if (view === "agenda") {
    end = addDays(date, 30);
  }
  return { start_date: format(start, "yyyy-MM-dd"), end_date: format(end, "yyyy-MM-dd") };
}
